var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClockGrey = function SvgClockGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M9.167 0a9.167 9.167 0 1 0 0 18.333A9.167 9.167 0 0 0 9.167 0Zm3.089 12.256a.833.833 0 0 1-1.178 0l-2.5-2.5a.833.833 0 0 1-.245-.59v-5a.833.833 0 1 1 1.667 0v4.656l2.256 2.256a.833.833 0 0 1 0 1.178Z"
  })));
};
export default SvgClockGrey;